<div class="parent" *ngIf="selectedGroup">
  <div>
    <!-- tag / team / lang -->
    <span class="alc-space-after" data-testid="group-label">
      {{ selectedGroup.label }}
    </span>
  </div>

  <div>
    <div *ngFor="let tagIdsAndPercentage of action.parameters.tagIdsAndPercentages; let i = index" class="field">
      <div class="alc-space-after" translate="triage_config/actions/random-dispatch/either"></div>

      <!-- sub item -->
      <div [attr.data-testid]="'subitem-label-' + i">{{ tagIdsAndPercentage.label }}</div>

      <div class="alc-space-before alc-space-after" translate="triage_config/actions/random-dispatch/at"></div>

      <!-- percentage -->
      <div class="alc-space-after" [attr.data-testid]="'percentage-' + i">{{ tagIdsAndPercentage.percentage }}%</div>
    </div>
  </div>
</div>
